/**
* DevExpress Analytics (query-builder\dataSource\object\objectSchema.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _dbSchema_1 = require("../_dbSchema");
var localization_utils_1 = require("../../../property-grid/localization/localization_utils");
var ObjectDataMemberBase = (function () {
    function ObjectDataMemberBase(model) {
        var _this = this;
        model && (function () {
            _this.name = model.name;
            _this.displayName = model.displayName;
            _this.dataMember = model.dataMember;
        })();
    }
    return ObjectDataMemberBase;
}());
exports.ObjectDataMemberBase = ObjectDataMemberBase;
var ObjectParameter = (function (_super) {
    __extends(ObjectParameter, _super);
    function ObjectParameter(model) {
        var _this = _super.call(this, model) || this;
        model && (function () {
            _this.value = model.value;
            _this.type = model.type;
            _this.resultType = model.resultType;
        })();
        return _this;
    }
    return ObjectParameter;
}(ObjectDataMemberBase));
exports.ObjectParameter = ObjectParameter;
var ObjectDataSourceMethodBase = (function (_super) {
    __extends(ObjectDataSourceMethodBase, _super);
    function ObjectDataSourceMethodBase(model) {
        var _this = _super.call(this, model) || this;
        _this.parameters = _dbSchema_1.deserializeToCollection(model.parameters, function (parameters) { return new ObjectParameter(parameters); });
        return _this;
    }
    return ObjectDataSourceMethodBase;
}(ObjectDataMemberBase));
exports.ObjectDataSourceMethodBase = ObjectDataSourceMethodBase;
var ObjectDataMember = (function (_super) {
    __extends(ObjectDataMember, _super);
    function ObjectDataMember(model) {
        var _this = _super.call(this, model) || this;
        _this.disabled = ko.observable(false);
        _this.memberType = model && model.memberType;
        _this.isStatic = model.isStatic;
        return _this;
    }
    ObjectDataMember.empty = function () {
        return new ObjectDataMember({
            displayName: ObjectDataMember.entireObject(),
            name: ObjectDataMember.entireObject(),
            parameters: []
        });
    };
    ObjectDataMember.prototype.isEntireObject = function () {
        return this.name == ObjectDataMember.entireObject() && this.displayName == ObjectDataMember.entireObject();
    };
    ObjectDataMember.prototype.isAvailable = function () {
        return !this.disabled();
    };
    ObjectDataMember.entireObject = function () { return localization_utils_1.getLocalization('Entire Object', 'AnalyticsCoreStringId.ObjectDSWizard_ConfigureParameters_EntireObject'); };
    return ObjectDataMember;
}(ObjectDataSourceMethodBase));
exports.ObjectDataMember = ObjectDataMember;
var ObjectCtor = (function (_super) {
    __extends(ObjectCtor, _super);
    function ObjectCtor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectCtor;
}(ObjectDataSourceMethodBase));
exports.ObjectCtor = ObjectCtor;
var ObjectType = (function (_super) {
    __extends(ObjectType, _super);
    function ObjectType(model) {
        var _this = _super.call(this, model) || this;
        _this.ctors = _dbSchema_1.deserializeToCollection(model.ctors, function (ctor) { return new ObjectCtor(ctor); });
        _this.members = _dbSchema_1.deserializeToCollection(model.members, function (member) { return new ObjectDataMember(member); });
        return _this;
    }
    ObjectType.prototype.updateMembers = function (selectedCtor) {
        this.members.forEach(function (member) {
            if (selectedCtor) {
                member.disabled(false);
            }
            else {
                member.disabled(member.isEntireObject() ? true : !member.isStatic);
            }
        });
    };
    return ObjectType;
}(ObjectDataMemberBase));
exports.ObjectType = ObjectType;
